import { Trash2 } from "lucide-react";

// A seller's own listing row with bid management (view bids + accept)
export const BidManagement = ({ listing, bids, onLoadBids, onRemove, onAccept }) => {
  return (
    <div className="bg-white/5 rounded-2xl p-6 border border-purple-500/20">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-semibold text-white">{listing.title}</h3>
          <p className="text-sm text-gray-400">${listing.price} • {listing.views} views • {listing.status}</p>
        </div>
        <div className="flex gap-2 items-center">
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${
            listing.status === 'active' ? 'bg-green-500/20 text-green-400' :
            listing.status === 'sold' ? 'bg-cyan-500/20 text-cyan-400' : 'bg-gray-500/20 text-gray-400'
          }`}>
            {listing.status}
          </span>
          {listing.status === 'active' && (
            <button
              onClick={() => onLoadBids(listing.id)}
              className="px-3 py-1.5 text-sm text-cyan-400 hover:bg-cyan-500/10 rounded-lg transition border border-cyan-500/30"
              data-testid={`view-bids-btn-${listing.id}`}
            >
              View Bids
            </button>
          )}
          {listing.status === 'active' && (
            <button
              onClick={() => onRemove(listing.id)}
              className="p-2 text-red-400 hover:bg-red-500/20 rounded-lg transition"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
      {bids && (
        <div className="mt-4 pt-4 border-t border-purple-500/20 space-y-2" data-testid={`bids-list-${listing.id}`}>
          {bids.length === 0 ? (
            <p className="text-sm text-gray-500">No bids yet on this listing.</p>
          ) : (
            bids.map((bid) => (
              <div key={bid.id} className="flex items-center justify-between bg-white/5 rounded-lg px-4 py-2">
                <div>
                  <p className="text-sm text-white font-medium">${bid.amount.toFixed(2)} <span className="text-gray-400 font-normal">— {bid.buyer_name}</span></p>
                  {bid.message && <p className="text-xs text-gray-500">{bid.message}</p>}
                </div>
                {bid.status === 'accepted' ? (
                  <span className="text-xs text-cyan-400">Accepted</span>
                ) : (
                  <button
                    onClick={() => onAccept(bid.id)}
                    className="px-3 py-1.5 text-xs bg-gradient-to-r from-purple-600 to-cyan-500 text-white rounded-lg font-medium hover:shadow-lg transition"
                    data-testid={`accept-bid-btn-${bid.id}`}
                  >
                    Accept
                  </button>
                )}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};
